<template>
  <div class="container">
    <componet
      :is="isAnchor ? 'a' : 'router-link'"
      :to="isAnchor ? undefined : link"
      :href="isAnchor ? link : undefined"
      :target="isAnchor ? '_blank' : undefined"
      class="is-block"
      
    >
      <div
        class="notification is-primary is-light card"
        style="border: 1px solid #eab4a0"
      >
        <div class="columns is-marginless is-mobile">
          <div class="column is-narrow pl-4 has-text-primary does-wiggle">
            <fa icon="bullhorn" class="fa-2x icon" />
          </div>
          <div class="column">
            <p>{{ text }}</p>
          </div>
          <div v-if="cta" class="has-text-weight-bold column is-narrow has-text-primary is-hidden-touch">
            {{ cta }}
          </div>
        </div>

        <div v-if="cta" class="has-text-weight-bold has-text-primary has-text-right is-hidden-desktop mt-2">
          {{ cta }}
        </div>
      </div>
    </componet>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    link: String,
    cta: String
  },
  computed: {
    isAnchor() {
      return this.link.startsWith("http")
    }
  }
};
</script>

<style>
.does-wiggle {
  animation: 2s wiggle ease infinite;
}

@keyframes wiggle {
  0% {
    transform: rotate(-3deg);
  }
  10% {
    transform: rotate(20deg);
  }
  20% {
    transform: rotate(-15deg);
  }
  30% {
    transform: rotate(5deg);
  }
  45% {
    transform: rotate(-1deg);
  }
  50% {
    transform: rotate(0);
  }
}
</style>